'use strict';

angular.module('p2pInvestorApp', [
		'ui.router'
	])
	.config(['$stateProvider', '$urlRouterProvider', '$locationProvider',
		function ($stateProvider, $urlRouterProvider, $locationProvider) {

			$locationProvider.html5Mode(true);

			$stateProvider
				.state('home', {
					url: '/',
					templateUrl: 'app/home/home.html'
				})
				.state('register', {
					url: '/register',
					templateUrl: 'app/register/register.html',
					controller: 'RegisterCtrl'
				})
				.state('profile-sites', {
					url: '/profile/sites',
					templateUrl: 'app/profile/sites-list.html',
					controller: 'SitesCtrl'
				})
				.state('profile-site', {
					params: {site: null},
					templateUrl: 'app/profile/site-edit.html',
					controller: 'SiteCrudCtrl',
					resolve: {
						InvestorSite: ['$stateParams', function ($stateParams) {
							return $stateParams.site;
						}]
					}
				})
				.state('profile-main', {
					url: '/profile/main',
					templateUrl: 'app/profile/main.html',
					controller: 'ProfileMainInfoCtrl'
				})
				.state('login', {
					url: '/login',
					templateUrl: 'app/login/login.html',
					controller: 'LoginCtrl'
				})
				.state('logout', {
					url: '/logout',
					resolve: {
						LoggedOut: ['User', function (User) {
							return User.logout();
						}]
					}
				});

			$urlRouterProvider.otherwise('/');

		}])
	.run(['$rootScope', '$state', '$stateParams', 'User', function ($rootScope, $state, $stateParams, User) {
		$rootScope.$state = $state;
		$rootScope.$stateParams = $stateParams;
		$rootScope.$app = {};

		$rootScope.$on('$stateChangeStart',
			function (event, toState /*, toParams, fromState, fromParams */) {
				$rootScope.location = toState.url;
			});

		User.checkSession();

		$rootScope.$on('user-authenticated', function (userName) {
			$rootScope.loggedInUser = userName;
		});

		$rootScope.$on('user-unauthenticated', function () {
			$rootScope.loggedInUser = null;
		});

		$rootScope.showOverlay = function () {
			$rootScope.overlayEnabled = true;
		};

		$rootScope.hideOverlay = function () {
			$rootScope.overlayEnabled = false;
		};

	}]);

'use strict';

angular.module('p2pInvestorApp')
	.service('Errors', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
		$rootScope.globalErrors = {};
		this.reportError = function (msg, autoClearError) {

			$rootScope.bugIconEnabled = true;
			$rootScope.bugMsg = msg;

			if (autoClearError) {
				$timeout(function () {
					$rootScope.clearError(name);
				}, 2000);
			}
		};
		this.clearError = function () {
			$rootScope.bugIconEnabled = false;
		};

		this.clearFormErrorMessages = function () {
			$('.has-error').removeClass('has-error');
			$('.help-block').addClass('hidden');
		};

		this.showFormErrorMessages = function (errorsList) {
			angular.forEach(errorsList, function (value) {
				$('#' + value.property + '\\.' + value.errorCode.replace(/\./g, "\\.")).removeClass("hidden");
				$('#' + value.property).parent('div').addClass("has-error");
			});
		};

		this.addValidationErrorIf = function (validationErrors, validationExpression, property, errorCode) {
			if (validationExpression) {
				validationErrors.push({property: property, errorCode: errorCode});
			}
		};

	}]);
'use strict';

angular.module('p2pInvestorApp')
	.service('User', ['$rootScope', '$http', '$timeout', '$state', function ($rootScope, $http, $timeout, $state) {

		var service = this;
		var userName = null;
		var timer;
		var checkTimeout = 180 * 1000;
		
		service.getUserName = function() {
			return userName;
		};

		service.setAuthenticated = function (name) {
			userName = name;
			$rootScope.$broadcast('user-authenticated', userName);
			service.startPolling();
		};

		service.navigateToHome = function () {
			$state.go("home");
		};

		service.setUnauthenticated = function () {
			userName = null;
			service.stopPolling();
			$rootScope.$broadcast('user-unauthenticated');
		};

		service.loadUserAgain = function () {
			$http.get('/services/public/get-logged-user').then(
				function (response) {
					service.setAuthenticated(response.data.name);
				});
		};

		service.checkSession = function () {
			$http.get('/services/public/loggedin').then(
				function (response) {
					if ('' + response.data === 'true') {
						if (!userName) {
							service.loadUserAgain();
						}
					} else {
						service.setUnauthenticated();
						service.navigateToHome();
					}
				},
				function (response) {
					service.setUnauthenticated();
					service.navigateToHome();
				});
		};

		var refreshSession = function () {
			try {
				service.checkSession();
			} finally {
			}
			timer = $timeout(refreshSession, checkTimeout);
		};

		service.startPolling = function () {
			timer = $timeout(refreshSession, checkTimeout);
		};

		service.stopPolling = function () {
			if (timer) {
				$timeout.cancel(timer);
			}
		};

		service.logout = function () {
			return $http.get('/logout').then(function (/* response */) {
				service.setUnauthenticated();
				service.navigateToHome();
			});
		};
		
	}]);
'use strict';

angular.module('p2pInvestorApp')
	.controller('LoginCtrl', ['$rootScope', '$scope', '$http', 'User', '$state', function ($rootScope, $scope, $http, User, $state) {

		$('#loginDialog').modal('show');

		$scope.login = function (event) {
			if (event !== undefined && event.keyCode !== 13) {
				return;
			}
			if (!$scope.name && !$scope.password) {
				showLoginFailed();
				User.setUnauthenticated();
				return;
			}
			$scope.loginFailed = false;

			var user = {
				'name': $scope.name,
				'password': $scope.password
			};
			$http.post('/services/public/login', user)
				.then(
					function (result) {
						if (result.data === true) {
							User.setAuthenticated(user.name);
							$('#loginDialog').modal('hide');
							$state.go('profile-main');
						} else {
							showLoginFailed();
							User.setUnauthenticated();
						}
					}
					, function () {
						User.setUnauthenticated();
						showLoginFailed();
					});
		};

		var showLoginFailed = function () {
			$scope.loginFailed = true;
		};

	}]);
'use strict';

angular.module('p2pInvestorApp')
	.controller('RegisterCtrl', ['$scope', '$state', '$http', "Errors", function ($scope, $state, $http, Errors) {

		$scope.investor = {};

		function requiredFieldValidation() {
			var errors = [];
			Errors.addValidationErrorIf(errors, !$scope.investor.email, "email", "required");
			Errors.addValidationErrorIf(errors, !$scope.investor.password, "password", "required");

			if (errors.length > 0) {
				Errors.showFormErrorMessages(errors);
			}
			return errors.length > 0;
		}

		$scope.register = function () {

			Errors.clearFormErrorMessages();

			if (requiredFieldValidation()) {
				return;
			}

			$scope.showOverlay();
			$http.post('/services/public/register', $scope.investor).then(
				function (result) {
					$scope.hideOverlay();
					$state.go("profile-sites");
				},
				function (result) {
					$scope.hideOverlay();
					Errors.showFormErrorMessages(result.data.errors);
				}
			);

		};

	}]);
'use strict';

angular.module('p2pInvestorApp')
	.controller('SitesCtrl', ['$scope', '$state', '$http', function ($scope, $state, $http) {

		$scope.add = function () {
			$state.go("profile-site");
		};

		$scope.list = function () {
			$http.get('/services/profile/sites').then(
				function (result) {
					$scope.sites = result.data;
				}
			);
		};

		$scope.refresh = function () {
			$scope.list();
		};

		$scope.edit = function (site) {
			$state.go('profile-site', {site: site});
		};

		$scope.delete = function (id) {
			$http.post('/services/profile/site/' + id + '/delete').then(
				function () {
					$scope.refresh();
				}
			)
		};

		$scope.list();
	}]);
'use strict';

angular.module('p2pInvestorApp')
	.controller('SiteCrudCtrl', ['$scope', '$state', '$http', 'InvestorSite', 'Errors', 'User',
		function ($scope, $state, $http, investorSite, Errors, User) {

			if (investorSite) {
				$scope.site = investorSite;
			} else {
				$scope.site = {
					login: User.getUserName()
				};
			}

			$scope.save = function () {
				var url;
				if ($scope.site.id) {
					url = '/services/profile/site/' + $scope.site.id + '/update';
					$scope.site.operation = 'UPDATE';
				} else {
					url = '/services/profile/site/add';
					$scope.site.operation = 'CREATE';
				}

				$scope.showOverlay();
				$http.post(url, $scope.site).then(
					function (response) {
						$scope.hideOverlay();
						$state.go("profile-sites");
					},
					function (response) {
						$scope.hideOverlay();
						Errors.showFormErrorMessages(response.data.errors);
					}
				)
			};

			$scope.cancel = function () {
				$state.go("profile-sites");
			};

		}]);
'use strict';

angular.module('p2pInvestorApp')
	.controller('ProfileMainInfoCtrl', ['$scope', '$state', '$http', function ($scope, $state, $http) {

		$scope.loadSitesDashboard = function () {
			$scope.showOverlay();
			$http.get('/services/profile/dashboard').then(
				function (result) {
					$scope.sitesDashboard = result.data;
					$scope.hideOverlay();
				},
				function (result) {
					$scope.hideOverlay();
				}
			);

			$scope.sitesDashboard = [{
				"siteName": "TWINO",
				"data": {"freeFunds": 9.77, "investments": 4343.31, "deposits": 4100.00, "withdrawals": 0.00, "xirr": 17.03, "income": 253.08}
			}, {
				"siteName": "MINTOS",
				"data": {"Available Funds": 26.01, "Total": 1903.40, "Interest": 52.58, "Late Payment Fees": 0.81, "31-60 days late": 124.23, "60+ days late": 0.00, "All income": 53.39}
			}]
		};

		$scope.loadSitesDashboard();

	}]);
'use strict';

angular.module('p2pInvestorApp')
	.controller('LoansListController', ['$scope', '$http', '$rootScope', function ($scope, $http, $rootScope) {

		$scope.queryDescription = '';
		$scope.loansResponse = {updateTime: ''};

		var siteName = $scope.siteName;

		$scope.loadLoansQueryDescription = function (siteName) {
			$http.get("/services/loans/best-public-query-description/" + siteName).then(
				function (success) {
					$scope.queryDescription = success.data;
				}
			);
		};

		$scope.siteLoans = function (siteName) {
			$scope.loansResponse = {updateTime: $scope.loansResponse.updateTime};
			$rootScope.showOverlay();
			$http.get("/services/loans/best-public/" + siteName).then(
				function (success) {
					$scope.loansResponse = success.data;
					$rootScope.hideOverlay();
				},
				function () {
					$rootScope.hideOverlay();
				}
			);
		};

		$scope.reload = function () {
			$scope.siteLoans($scope.siteName);
		};

		$scope.loadLoansQueryDescription($scope.siteName);

	}])
	.directive('loanList', function () {
			return {
				restrict: 'E',
				replace: true,
				transclude: true,
				templateUrl: 'app/profile/loan-list.html',
				scope: {
					siteName: '='
				},
				controller: 'LoansListController'
			};

		}
	);